import React, { useState } from 'react';
import StancerCVCContainer from './StancerCVCContainer';
import StancerSavedCardContainer from './StancerSavedCardContainer';
import { Box } from '@material-ui/core';
import useStyles from './styles';

/**
 * @name StancerSavedCardFlow - jsx component for Stancer flow
 * @param {boolean} savedCards - Specifies upfront cost is present or not
 * @returns {JSX.Element} - Renders StancerSavedCardFlow component
 */
const StancerSavedCardFlow = props => {
    const [step, setStep] = useState(0);
    const classes = useStyles();
    const [hpp, setHpp] = useState(null);
    const [loadCvc, setLoadCvc] = useState(false);

    return (
        <Box className={classes.savedCardFlow}>
            {
                {
                    0: (
                        <StancerSavedCardContainer
                            cards={props.cards}
                            handleBack={props?.handleBack}
                            setStatus={props?.setStatus}
                            handleNext={props?.handleNext}
                            setHeader={props?.setHeader}
                            handleMultiPaymentData={props?.handleMultiPaymentData}
                            toggle={props?.toggle}
                            setPaidAmount={props?.setPaidAmount}
                            payableAmount={props?.payableAmount}
                            hpp={hpp}
                            loadCvc={loadCvc}
                            setHpp={setHpp}
                            setLoadCvc={setLoadCvc}
                            setLoading={props.setLoading}
                            setStep={setStep}
                            graphql={props.graphql}
                        />
                    ),
                    1: (
                        <StancerCVCContainer
                            hpp={hpp}
                            graphql={props.graphql}
                            loading={props.loading}
                            handleBack={props?.handleBack}
                            setStatus={props?.setStatus}
                            handleNext={props?.handleNext}
                            setHeader={props?.setHeader}
                            setPaidAmount={props?.setPaidAmount}
                            payableAmount={props?.payableAmount}
                        />
                    ),
                }[step]
            }
        </Box>
    );
};
export default StancerSavedCardFlow;
